import { Facebook, Instagram, Twitter, Youtube, Mail, Phone, MapPin, Heart, Shield, Users } from 'lucide-react';

const FooterV2 = () => {
  return (
    <footer className="bg-[#003f63] text-white relative border-t border-[#00b5ad]">
      
      <div className="container mx-auto px-6 py-16">
        {/* Section principale - Layout horizontal moderne */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12">
          
          {/* Logo et mission - Plus large */}
          <div className="lg:col-span-5 space-y-6">
            <div className="flex items-start space-x-4">
              <img 
                src="/images/cropped-ChatGPT-Image-24-oct.-2025-19_43_53-e1761384975568.png" 
                alt="Logo Santé des Articulations" 
                className="h-16 w-16 object-contain flex-shrink-0"
              />
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-white mb-1 leading-tight">Santé Articulations</h3>
                <p className="text-[#00b5ad] font-medium mb-3">Votre bien-être articulaire</p>
                <p className="text-[#00b5ad] font-medium text-lg italic">
                  "Préserver la mobilité naturellement"
                </p>
              </div>
            </div>
            
            <p className="text-gray-300 text-base leading-relaxed">
              Nous vous accompagnons dans votre quête d'une mobilité optimale grâce à des approches naturelles, 
              des conseils d'experts et des solutions personnalisées pour chaque étape de votre parcours santé.
            </p>
            
            {/* Statistiques ou points forts */}
            <div className="grid grid-cols-3 gap-4 pt-4">
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  <Heart className="h-6 w-6 text-[#00b5ad]" />
                </div>
                <p className="text-sm text-gray-300">Solutions<br/>Naturelles</p>
              </div>
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  <Shield className="h-6 w-6 text-[#00b5ad]" />
                </div>
                <p className="text-sm text-gray-300">Conseils<br/>d'Experts</p>
              </div>
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  <Users className="h-6 w-6 text-[#00b5ad]" />
                </div>
                <p className="text-sm text-gray-300">Communauté<br/>Active</p>
              </div>
            </div>
          </div>

          {/* Navigation rapide */}
          <div className="lg:col-span-2 space-y-4">
            <h4 className="text-lg font-semibold text-white mb-4 relative">
              Navigation
              <div className="absolute bottom-0 left-0 w-8 h-0.5 bg-[#00b5ad]"></div>
            </h4>
            <nav className="space-y-3">
              <a href="#accueil" className="block text-gray-300 hover:text-[#00b5ad] transition-colors duration-300 text-sm">
                Accueil
              </a>
              <a href="#blog" className="block text-gray-300 hover:text-[#00b5ad] transition-colors duration-300 text-sm">
                Blog & Actualités
              </a>
              <a href="#guide" className="block text-gray-300 hover:text-[#00b5ad] transition-colors duration-300 text-sm">
                Guide Complet
              </a>
              <a href="#exercices" className="block text-gray-300 hover:text-[#00b5ad] transition-colors duration-300 text-sm">
                Exercices
              </a>
              <a href="#nutrition" className="block text-gray-300 hover:text-[#00b5ad] transition-colors duration-300 text-sm">
                Nutrition
              </a>
            </nav>
          </div>

          {/* Ressources */}
          <div className="lg:col-span-2 space-y-4">
            <h4 className="text-lg font-semibold text-white mb-4 relative">
              Ressources
              <div className="absolute bottom-0 left-0 w-8 h-0.5 bg-[#00b5ad]"></div>
            </h4>
            <nav className="space-y-3">
              <a href="#supplements" className="block text-gray-300 hover:text-[#00b5ad] transition-colors duration-300 text-sm">
                Compléments Naturels
              </a>
              <a href="#prevention" className="block text-gray-300 hover:text-[#00b5ad] transition-colors duration-300 text-sm">
                Prévention
              </a>
              <a href="#temoignages" className="block text-gray-300 hover:text-[#00b5ad] transition-colors duration-300 text-sm">
                Témoignages
              </a>
              <a href="#faq" className="block text-gray-300 hover:text-[#00b5ad] transition-colors duration-300 text-sm">
                FAQ
              </a>
              <a href="#contact" className="block text-gray-300 hover:text-[#00b5ad] transition-colors duration-300 text-sm">
                Contact
              </a>
            </nav>
          </div>

          {/* Contact et réseaux */}
          <div className="lg:col-span-3 space-y-6">
            <h4 className="text-lg font-semibold text-white mb-4 relative">
              Restons Connectés
              <div className="absolute bottom-0 left-0 w-8 h-0.5 bg-[#00b5ad]"></div>
            </h4>
            
            {/* Informations de contact */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-gray-300 text-sm">
                <Mail className="h-4 w-4 text-[#00b5ad] flex-shrink-0" />
                <span>contact@sante-articulations.fr</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300 text-sm">
                <Phone className="h-4 w-4 text-[#00b5ad] flex-shrink-0" />
                <span>01 23 45 67 89</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300 text-sm">
                <MapPin className="h-4 w-4 text-[#00b5ad] flex-shrink-0" />
                <span>Paris, France</span>
              </div>
            </div>
            
            {/* Réseaux sociaux */}
            <div>
              <p className="text-sm font-medium text-white mb-3">Suivez-nous</p>
              <div className="flex space-x-3">
                <a 
                  href="#facebook" 
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#00b5ad] transition-all duration-300 group"
                  aria-label="Facebook"
                >
                  <Facebook className="h-4 w-4 text-gray-300 group-hover:text-white" />
                </a>
                <a 
                  href="#instagram" 
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#00b5ad] transition-all duration-300 group"
                  aria-label="Instagram"
                >
                  <Instagram className="h-4 w-4 text-gray-300 group-hover:text-white" />
                </a>
                <a 
                  href="#twitter" 
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#00b5ad] transition-all duration-300 group"
                  aria-label="Twitter"
                >
                  <Twitter className="h-4 w-4 text-gray-300 group-hover:text-white" />
                </a>
                <a 
                  href="#youtube" 
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#00b5ad] transition-all duration-300 group"
                  aria-label="YouTube"
                >
                  <Youtube className="h-4 w-4 text-gray-300 group-hover:text-white" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Avertissement médical - Design plus intégré */}
        <div className="bg-gradient-to-r from-orange-900/30 to-red-900/30 border-l-4 border-orange-400 rounded-r-lg p-6 mb-8">
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0">
              <svg className="h-6 w-6 text-orange-400 mt-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </div>
            <div>
              <h5 className="font-semibold text-orange-300 mb-2 text-lg">⚠️ Avertissement Médical Important</h5>
              <p className="text-orange-100 text-sm leading-relaxed">
                <strong>Les informations présentées sur ce site sont à des fins éducatives uniquement et ne constituent pas des conseils médicaux.</strong> 
                Consultez toujours votre médecin avant de commencer tout programme d'exercices ou de modifier votre alimentation.
              </p>
            </div>
          </div>
        </div>

        {/* Footer bottom - Plus moderne */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
            
            {/* Copyright */}
            <div className="text-gray-400 text-sm">
              © 2025 Santé des Articulations. Tous droits réservés.
            </div>

            {/* Liens légaux - Design horizontal */}
            <div className="flex flex-wrap justify-center lg:justify-end gap-6 text-sm">
              <a href="#mentions-legales" className="text-gray-400 hover:text-[#00b5ad] transition-colors duration-300">
                Mentions Légales
              </a>
              <a href="#politique-confidentialite" className="text-gray-400 hover:text-[#00b5ad] transition-colors duration-300">
                Confidentialité
              </a>
              <a href="#conditions-utilisation" className="text-gray-400 hover:text-[#00b5ad] transition-colors duration-300">
                CGU
              </a>
              <a href="#cookies" className="text-gray-400 hover:text-[#00b5ad] transition-colors duration-300">
                Cookies
              </a>
              <a href="#avertissement-medical" className="text-gray-400 hover:text-[#00b5ad] transition-colors duration-300">
                Avertissement Médical
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterV2;